import React from "react";
import { Card, CardContent, Box, Typography, CardHeader } from "@mui/material";
import AlertMessage from "../../../Common/Alert/AlertMessage";
import RMSAvatar from "../RMSAvatar";

function AppraisalErrorCard({ error, message }) {
    return (
        <Card sx={{ width: "100%" }} className="card">
            <CardHeader
                avatar={<RMSAvatar type={"appraisal"} />}
                title={
                    <Typography variant="h2" className="card-header-title">
                        Appraisal
                    </Typography>
                }
                subheader={
                    <Typography
                        component="span"
                        className="card-header-subtitle"
                    >
                        {error}
                    </Typography>
                }
            />
            <CardContent>
                <Box className="card-content">
                    <AlertMessage severity="warning" message={message} />
                </Box>
            </CardContent>
        </Card>
    );
}

export default AppraisalErrorCard;
